import type { ReactNode } from 'react';

import { CaptionStrong } from 'components/atoms/LegacyText';
import Tooltip from '../Tooltip';
import * as Styled from './InputError.styled';

export type InputErrorProps = {
  errors?: string[];
  showErrorAsTooltip?: boolean;
  icon?: ReactNode;
};

export const InputError = ({
  errors = [],
  showErrorAsTooltip,
  icon,
}: InputErrorProps) => {
  if (!errors?.length) {
    return null;
  }

  if (showErrorAsTooltip) {
    return (
      <Styled.TooltipWrapper>
        <Tooltip
          content={
            <CaptionStrong data-test-id="input-error" role="alert">
              {errors.join(', ')}
            </CaptionStrong>
          }
          placement="top-start"
        >
          <Styled.TooltipIcon
            data-test-id="input-error-icon"
            customFill={true}
          />
        </Tooltip>
      </Styled.TooltipWrapper>
    );
  }

  return (
    <Styled.ErrorWrapper $hasIcon={!!icon}>
      {icon && <Styled.IconWrapper>{icon}</Styled.IconWrapper>}
      <Styled.ErrorCaption
        $hasIcon={!!icon}
        data-test-id="input-error"
        role="alert"
      >
        {errors.join(', ')}
      </Styled.ErrorCaption>
    </Styled.ErrorWrapper>
  );
};

export default InputError;
